module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', {
    staticClass: "mycoupon"
  }, [_vm._v("我的优惠券")]), _vm._v(" "), _vm._l((_vm.mycoupon), function(coupon) {
    return _c('div', {
      staticClass: "Vouchers"
    }, [_c('div', {
      staticClass: "VouchersLeft"
    }, [_c('div', {
      staticClass: "amountNumber"
    }, [_c('span', [_vm._v(_vm._s(coupon.price))]), _vm._v(" 元"), _c('i', [_vm._v(_vm._s(coupon.name))])]), _vm._v(" "), _c('p', {
      staticClass: "moneyTime"
    }, [_vm._v("满" + _vm._s(coupon.condition) + "可以使用")]), _vm._v(" "), _c('p', {
      staticClass: "moneyTime"
    }, [_vm._v("有效期：" + _vm._s(coupon.time_out))]), _vm._v(" "), _c('b', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (coupon.end_time_status == 0 ? true : false),
        expression: "coupon.end_time_status==0?true:false"
      }],
      staticClass: "term"
    }, [_vm._v("即将过期")])]), _vm._v(" "), _c('div', {
      staticClass: "VouchersRight",
      on: {
        "click": function($event) {
          _vm.use(coupon)
        }
      }
    }, [_vm._v("立"), _c('br'), _vm._v("即"), _c('br'), _vm._v("使"), _c('br'), _vm._v("用")])])
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5e265a2c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/orderList/Mycoupons.vue
// module id = 554
// module chunks = 1